<template>
  <div class="bottom-safe" :style="{ 'padding-top': offsetHeight + 'px' }">
    <van-nav-bar
      v-if="fullPathToTopic"
      :fixed="true"
      :title="topic.title"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      ref="navBar"
    />
    <show-image
      v-if="topic.cover"
      :imgId="topic.cover"
    />
    <div class="description">
      {{topic.description}}
    </div>
    <EpisodeList
      :slug="slug"
      :episode-ids="topic.episode_ids"
      :limit="0"
      @got-episodes-count="gotEpisodesCount"
    />
  </div>
</template>

<script>
  import store from '../../../store/index'
  import Vue from 'vue'
  import { NavBar } from 'vant'
  import ShowImage from '../../show-image.vue'
  import EpisodeList from '../../episode-list.vue'
  Vue.use(NavBar)

  export default {
    name: "TopicDetail",
    components: {
      ShowImage,
      EpisodeList
    },
    data () {
      return {
        // title: '',
        fullPathToTopic: '',
        topic: {
          id: null,
          show: ''
        },
        offsetHeight: 0
      }
    },
    computed: {
      slug () {
        return this.topic.show_slug
      }
    },
    methods: {
      onClickLeft() {
        store.commit("clearPrevFullPath")
        this.$router.replace({
          path: this.fullPathToTopic
        })
      },
      loadTopic () {
        let that = this
        let topicId = this.$route.params.topicId
        that.$api.topic.detail(topicId).then(res => {
          that.topic = res.data
          // that.title = res.data.label
        })
      },
      gotEpisodesCount (count) {
        window.console.log('gotEpisodesCount:', count)
        // this.title = `${this.title} ${count} 期`
      }
    },
    watch: {
      episode (value) {
        // value: episode
        if (value.audios.length > 0) {
          this.hasAudios = true
        } else {
          this.hasAudios = false
        }
        if (value.videos.length > 0) {
          this.hasVideos = true
        } else {
          this.hasVideos = false
        }
      }
    },
    mounted () {
      let that = this
      if (store.state.fullPathToTopic) {
        that.fullPathToTopic = store.state.fullPathToTopic
        if (store.state.fullPathToTopic) {
          that.$nextTick(function() {
            that.offsetHeight = that.$refs.navBar.$el.offsetHeight
          })
        }
      }
      that.loadTopic()
    }
  }
</script>

<style lang="css" scoped>
  .description {
    background: #fff;
    padding: 16px;
    margin-bottom: 16px;
    white-space: pre-wrap;
  }
</style>
